import React, { useState,useEffect } from "react";
import Chart from "react-apexcharts";
import CurrentjobTabledata from "./CurrentjobTabledata";
import { getAuthorization } from "../../../axios/AxiosAut";

export default function SchedularStatistics() {
  const [Data, setData] = useState([]);
  const getData = () => {
    getAuthorization()
      .get(`dashboard/management/get_perfect_schedule_rate/`)
      .then((res) => {
        console.log("perfect schedule data", res.data
        );
        setData(res.data
          );
      })
      .catch((err) => {
        console.log("err", err);
      });
  };
  useEffect(() => {
    getData();
    console.log("perfect schedule data.....", Data);
  }, []);


  const [PerferctSchedule, SetPerferctSchedule] = useState({
    options: {
      chart: {
        toolbar: {
          show: false,
        },
      },
      colors: ["#1F78B4"],

      xaxis: {
        categories: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
      },
      yaxis: {
        forceNiceScale: false,
        max: 100,
        labels: {
          formatter: (value) => value.toFixed(0) + "%",
        },
      },
      stroke: {
        curve: "smooth",
      },
      markers: {
        size: 4,
      },
      states: {
        normal: {
          filter: {
            type: "none",
            value: 0,
          },
        },
        hover: {
          filter: {
            type: "lighten",
            value: 0.15,
          },
        },
        active: {
          allowMultipleDataPointsSelection: false,
          filter: {
            type: "darken",
            value: 0.35,
          },
        },
      },
    },

    series: [
      {
        name: "PerferctSchedule Order Rate",
        data: [83, 80, 92, 87, 95, 90, 97, 87, 84, 78, 87, 96],
      },
    ],
  });
  const state = {
    stroke: {
      lineCap: "round",
    },
    options: {
      dataLabels: {
        enabled: false,
      },
      legend: {
        fontSize: "14px",
        fontFamily: "Poppins",
        position: "bottom",
        horizontalAlign: "center",
        // labels: {
        //   show: true,
        //   name: "Total Issus",
        //   value: 263,
        // },
      },
      title: {
        text: "26",
        align: "center",
        margin: 10,
        offsetX: 0,
        offsetY: 105,
        floating: false,
        style: {
          fontSize: "18px",
          fontWeight: "bold",
          color: "#000",
        },
      },
      subtitle: {
        text: "Current Jobs",
        align: "center",
        margin: 10,
        offsetX: 0,
        offsetY: 135,
        floating: false,
        style: {
          fontSize: "16px",
          fontWeight: "bold",
          color: "#000",
        },
      },
      // subtitle: {
      //   text: ,
      //   align: "center",
      //   margin: 10,
      //   offsetX: 0,
      //   offsetY: 105,
      //   floating: false,
      //   style: {
      //     fontSize: "14px",
      //     fontWeight: "bold",
      //     color: "#000",
      //   },
      // },
      labels: ["Issue", "OnGoing", "Pause"],
      colors: ["#FF0000", "#00FF00", "#FFFF00"],

      plotOptions: {
        pie: {
          customScale: 1,
          donut: {
            size: "83%",
            // labels: {
            //   show: true,
            //   name: "Total Issus",
            //   value: 263,
            // },
          },
        },
      },
    },

    series: [45, 35, 20],
  };
  return (
    <div>
      <div className="flex mt-10 space-x-15 bg-white shadow-lg border-cyan-100 border-1 rounded-lg md:space-x-10 sm:space-x-5 pt-4 px-8 pb-8">
        <div className="flex-4">
          <div className="flex flex-wrap mr-4 pt-2">
            <div className="flex float-right ml-auto mr-4 mt-1">
              <div className="relative text-gray-600 mr-3  border-1 rounded-3xl ml-10 float-right focus-within:text-gray-400">
                <span className="absolute text-slate-400 inset-y-0 left-0 flex items-center pl-2">
                  <button
                    type="submit"
                    className="p-1 focus:outline-none focus:shadow-outline"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      stroke-width="2"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M4 6h16M4 12h8m-8 6h16"
                      />
                    </svg>
                  </button>
                </span>
                <input
                  type="search"
                  className="py-2 text-sm outline-slate-100 outline rounded-full pl-10 focus:outline-1 focus:outline-slate-200 focus:bg-white focus:text-gray-900"
                  placeholder="Filter"
                  autocomplete="off"
                />
              </div>

              <div className="mt-2">
                <button className="rounded-full text-blue-900 w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                  {" "}
                  Y
                </button>
              </div>
              <div className="mt-2">
                <button className="rounded-full w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-blue-200 text-lg font-bold text-white outline-1 mx-2">
                  {" "}
                  M
                </button>
              </div>
              <div class=" flex border-b border-blue-200 ml-4 mr-4 ">
                <input
                  class="w-full bg-transparent placeholder-blue-200 rounded-lg p-2"
                  type="text"
                  placeholder="Search Specific Group"
                />
                <button class=" w-auto flex justify-end items-center text-blue p-2 hover:text-blue-light">
                  <svg
                    width="19"
                    height="19"
                    viewBox="0 0 19 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M18.1206 13.7553L13.5772 9.87719C14.4317 8.87406 14.9369 7.64031 14.9369 6.30781C14.9369 2.95469 11.7409 0.226562 7.81186 0.226562C3.88358 0.226562 0.6875 2.95469 0.6875 6.30781C0.6875 9.66156 3.88358 12.3891 7.81186 12.3891C9.30116 12.3891 10.6843 11.9972 11.8295 11.3278L16.397 15.2266L18.1206 13.7553ZM2.77721 6.30781C2.77721 3.93781 5.03607 2.00969 7.81259 2.00969C10.5891 2.00969 12.848 3.93781 12.848 6.30781C12.848 8.67781 10.5891 10.6059 7.81259 10.6059C5.03534 10.6059 2.77721 8.67781 2.77721 6.30781Z"
                      fill="#1F78B4"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
          <div className="flex mt-8">
            <div className="bg-white shadow-lg border-cyan-100 border-1 space-x-15  rounded-lg hover:border-blue-200 hover:shadow-xl w-full align-middle font-Montserrat">
              <div className="flex flex-col items-center py-4 font-Montserrat">
                <div className="text-center  mt-4">
                  <div className="text-center">
                    <button className=" text-center rounded-full w-12  bg-cyan-200 text-lg font-bold outline-1 mx-2">
                      {" "}
                      <svg
                        className="relative top-1.5 left-1.5"
                        width="42"
                        height="42"
                        viewBox="0 0 32 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M2 14L5.23309 16.4248C5.66178 16.7463 6.26772 16.6728 6.60705 16.2581L15 6"
                          stroke="#1F78B4"
                          stroke-linecap="round"
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M10.191 15.3932L11.9153 16.7726C12.5572 17.2861 13.4928 17.1873 14.0133 16.5511L22.387 6.31663C22.5618 6.10291 22.5303 5.7879 22.3166 5.61304C22.1029 5.43817 21.7879 5.46967 21.613 5.6834L13.2393 15.9179C13.0658 16.13 12.754 16.1629 12.54 15.9917L10.8243 14.6192L10.191 15.3932Z"
                          fill="#1F78B4"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
                <h1 className="text-4xl text-center font-bold mt-4">34%</h1>
                <h1 className="text-lg text-center text-gray-500 mt-2 font-bold ">
                  Completed on time
                </h1>
                <p className="text-lime-400 text-center mb-1 ">
                  <span>
                    <span className="inline-block">
                      <svg
                        width="14"
                        height="14"
                        viewBox="0 0 12 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7 7L7.70711 6.29289L7 5.58579L6.29289 6.29289L7 7ZM11.2071 9.79289L7.70711 6.29289L6.29289 7.70711L9.79289 11.2071L11.2071 9.79289ZM6.29289 6.29289L2.79289 9.79289L4.20711 11.2071L7.70711 7.70711L6.29289 6.29289Z"
                          fill="#26F32E"
                        />
                        <path
                          d="M7 3.5L7.70711 2.79289L7 2.08579L6.29289 2.79289L7 3.5ZM11.2071 6.29289L7.70711 2.79289L6.29289 4.20711L9.79289 7.70711L11.2071 6.29289ZM6.29289 2.79289L2.79289 6.29289L4.20711 7.70711L7.70711 4.20711L6.29289 2.79289Z"
                          fill="#26F32E"
                        />
                      </svg>
                    </span>
                  </span>
                  <span className="ml-1 font-medium">45.38%</span>
                </p>
                <div className="text-center m-auto flex justify-center ml-auto mt-1 mb-4 pt-3">
                  <div className="">
                    <button className="rounded-full w-8 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                      {" "}
                      Y
                    </button>
                  </div>
                  <div className="">
                    <button className="rounded-full w-8 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                      {" "}
                      M
                    </button>
                  </div>

                  <div className="">
                    <button className="rounded-full w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-blue-200 text-lg font-bold text-white outline-1 mx-2">
                      {" "}
                      W
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-white shadow-lg border-cyan-100 border-1 space-x-15 ml-8 rounded-lg hover:border-blue-200 hover:shadow-xl w-full align-middle font-Montserrat">
              <div className="flex flex-col items-center py-4 font-Montserrat">
                <div className="text-center  mt-4 ">
                  <div className="text-center">
                    <button className=" text-center rounded-full w-12  bg-cyan-200 text-lg font-bold outline-1 mx-2">
                      {" "}
                      <svg
                        className="relative top-1.5 left-1.5"
                        width="44"
                        height="44"
                        viewBox="0 0 32 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle cx="12" cy="14" r="8" stroke="#1F78B4" />
                        <path
                          d="M12 14L12 11"
                          stroke="#1F78B4"
                          stroke-linecap="round"
                        />
                        <path
                          d="M17.5 7.5L19 6"
                          stroke="#1F78B4"
                          stroke-linecap="round"
                        />
                        <path
                          d="M10.0681 2.37059C10.1821 2.26427 10.4332 2.17033 10.7825 2.10332C11.1318 2.03632 11.5597 2 12 2C12.4403 2 12.8682 2.03632 13.2175 2.10332C13.5668 2.17033 13.8179 2.26427 13.9319 2.37059"
                          stroke="#1F78B4"
                          stroke-linecap="round"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
                <h1 className="text-4xl text-center font-bold mt-4">62%</h1>
                <h1 className="text-lg text-center text-gray-500 mt-2 font-bold ">
                  On going Orders
                </h1>
                <p className="text-lime-400 text-center mb-1 ">
                  <span>
                    <span className="inline-block">
                      <svg
                        width="14"
                        height="14"
                        viewBox="0 0 12 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7 7L7.70711 6.29289L7 5.58579L6.29289 6.29289L7 7ZM11.2071 9.79289L7.70711 6.29289L6.29289 7.70711L9.79289 11.2071L11.2071 9.79289ZM6.29289 6.29289L2.79289 9.79289L4.20711 11.2071L7.70711 7.70711L6.29289 6.29289Z"
                          fill="#26F32E"
                        />
                        <path
                          d="M7 3.5L7.70711 2.79289L7 2.08579L6.29289 2.79289L7 3.5ZM11.2071 6.29289L7.70711 2.79289L6.29289 4.20711L9.79289 7.70711L11.2071 6.29289ZM6.29289 2.79289L2.79289 6.29289L4.20711 7.70711L7.70711 4.20711L6.29289 2.79289Z"
                          fill="#26F32E"
                        />
                      </svg>
                    </span>
                  </span>
                  <span className="ml-1 font-medium">45.38%</span>
                </p>
                <div className="text-center m-auto flex justify-center ml-auto mt-1 mb-4 pt-3">
                  <div className="">
                    <button className="rounded-full w-8 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                      {" "}
                      Y
                    </button>
                  </div>
                  <div className="">
                    <button className="rounded-full w-8 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                      {" "}
                      M
                    </button>
                  </div>

                  <div className="">
                    <button className="rounded-full w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-blue-200 text-lg font-bold text-white outline-1 mx-2">
                      {" "}
                      W
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-white shadow-lg border-cyan-100 border-1 space-x-15 ml-8 rounded-lg hover:border-blue-200 hover:shadow-xl w-full align-middle font-Montserrat">
              <div className="flex flex-col items-center py-4 font-Montserrat">
                <div className="text-center  mt-4 ">
                  <div className="text-center">
                    <button className=" text-center rounded-full w-12  bg-cyan-200 text-lg font-bold outline-1 mx-2">
                      {" "}
                      <svg
                        className="relative top-1.5 left-1.5"
                        width="44"
                        height="44"
                        viewBox="0 0 32 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle cx="12" cy="12" r="8.5" stroke="#1F78B4" />
                        <path
                          d="M16.2426 7.75736C15.1174 6.63214 13.5913 6 12 6C10.4087 6 8.88258 6.63214 7.75736 7.75736C6.63214 8.88258 6 10.4087 6 12C6 13.5913 6.63214 15.1174 7.75736 16.2426L12 12L16.2426 7.75736Z"
                          fill="#1F78B4"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
                <h1 className="text-4xl text-center font-bold mt-4">07%</h1>
                <h1 className="text-lg text-center text-gray-500 mt-2 font-bold ">
                  Paused orders
                </h1>
                <p className="text-red-600 text-center mb-1">
                  <span>
                    <span className="inline-block">
                      <svg
                        width="14"
                        height="14"
                        viewBox="0 0 12 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7 7L7.70711 6.29289L7 5.58579L6.29289 6.29289L7 7ZM11.2071 9.79289L7.70711 6.29289L6.29289 7.70711L9.79289 11.2071L11.2071 9.79289ZM6.29289 6.29289L2.79289 9.79289L4.20711 11.2071L7.70711 7.70711L6.29289 6.29289Z"
                          fill="#F32626"
                        />
                        <path
                          d="M7 3.5L7.70711 2.79289L7 2.08579L6.29289 2.79289L7 3.5ZM11.2071 6.29289L7.70711 2.79289L6.29289 4.20711L9.79289 7.70711L11.2071 6.29289ZM6.29289 2.79289L2.79289 6.29289L4.20711 7.70711L7.70711 4.20711L6.29289 2.79289Z"
                          fill="#F32626"
                        />
                      </svg>
                    </span>
                  </span>
                  <span className="ml-1 font-medium">03.88%</span>
                </p>
                <div className="text-center m-auto flex justify-center ml-auto mt-1 mb-4 pt-3">
                  <div className="">
                    <button className="rounded-full w-8 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                      {" "}
                      Y
                    </button>
                  </div>
                  <div className="">
                    <button className="rounded-full w-8 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                      {" "}
                      M
                    </button>
                  </div>

                  <div className="">
                    <button className="rounded-full w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-blue-200 text-lg font-bold text-white outline-1 mx-2">
                      {" "}
                      W
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-white shadow-lg border-cyan-100 border-1 space-x-15 ml-8 rounded-lg hover:border-blue-200 hover:shadow-xl w-full align-middle font-Montserrat">
              <div className="flex flex-col items-center py-4 font-Montserrat">
                <div className="text-center  mt-4 ">
                  <div className="text-center">
                    <button className=" text-center rounded-full w-12  bg-cyan-200 text-lg font-bold outline-1 mx-2">
                      {" "}
                      <svg
                        className="relative top-1 left-1"
                        width="44"
                        height="44"
                        viewBox="0 0 32 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M14.6399 0.519531L26.8515 21.6707H2.42821L14.6399 0.519531Z"
                          fill="#1F78B4"
                        />
                        <path
                          d="M15.742 9.46328L15.502 16.7083H13.732L13.477 9.46328H15.742ZM14.662 20.2183C14.282 20.2183 13.967 20.1033 13.717 19.8733C13.477 19.6333 13.357 19.3383 13.357 18.9883C13.357 18.6383 13.477 18.3483 13.717 18.1183C13.967 17.8783 14.282 17.7583 14.662 17.7583C15.032 17.7583 15.337 17.8783 15.577 18.1183C15.817 18.3483 15.937 18.6383 15.937 18.9883C15.937 19.3383 15.817 19.6333 15.577 19.8733C15.337 20.1033 15.032 20.2183 14.662 20.2183Z"
                          fill="white"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
                <h1 className="text-4xl text-center font-bold mt-4">86%</h1>
                <h1 className="text-lg text-center text-gray-500 mt-2 font-bold ">
                  Orders with issues
                </h1>
                <p className="text-red-600 text-center mb-1">
                  <span>
                    <span className="inline-block">
                      <svg
                        width="14"
                        height="14"
                        viewBox="0 0 12 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7 7L7.70711 6.29289L7 5.58579L6.29289 6.29289L7 7ZM11.2071 9.79289L7.70711 6.29289L6.29289 7.70711L9.79289 11.2071L11.2071 9.79289ZM6.29289 6.29289L2.79289 9.79289L4.20711 11.2071L7.70711 7.70711L6.29289 6.29289Z"
                          fill="#F32626"
                        />
                        <path
                          d="M7 3.5L7.70711 2.79289L7 2.08579L6.29289 2.79289L7 3.5ZM11.2071 6.29289L7.70711 2.79289L6.29289 4.20711L9.79289 7.70711L11.2071 6.29289ZM6.29289 2.79289L2.79289 6.29289L4.20711 7.70711L7.70711 4.20711L6.29289 2.79289Z"
                          fill="#F32626"
                        />
                      </svg>
                    </span>
                  </span>
                  <span className="ml-1 font-medium">03.88%</span>
                </p>
                <div className="text-center m-auto flex justify-center ml-auto mt-1 mb-4 pt-3">
                  <div className="">
                    <button className="rounded-full w-8 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                      {" "}
                      Y
                    </button>
                  </div>
                  <div className="">
                    <button className="rounded-full w-8 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                      {" "}
                      M
                    </button>
                  </div>

                  <div className="">
                    <button className="rounded-full w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-blue-200 text-lg font-bold text-white outline-1 mx-2">
                      {" "}
                      W
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex mt-10 space-x-15 bg-white shadow-lg border-cyan-100 border-1 rounded-lg md:space-x-10 sm:space-x-5 pt-4 px-8 pb-8">
        <div className="flex-4">
          <div className="flex flex-wrap mr-4 pt-2">
            <h3 className="text-lg font-bold mx-3">
              Perfect schedule order rate
            </h3>

            <div className="flex float-right ml-auto mr-4 mt-1">
              <div className="relative text-gray-600 mr-3  border-1 rounded-3xl ml-10 float-right focus-within:text-gray-400">
                <span className="absolute text-slate-400 inset-y-0 left-0 flex items-center pl-2">
                  <button
                    type="submit"
                    className="p-1 focus:outline-none focus:shadow-outline"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      stroke-width="2"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M4 6h16M4 12h8m-8 6h16"
                      />
                    </svg>
                  </button>
                </span>
                <input
                  type="search"
                  className="py-2 text-sm outline-slate-100 outline rounded-full pl-10 focus:outline-1 focus:outline-slate-200 focus:bg-white focus:text-gray-900"
                  placeholder="Filter"
                  autocomplete="off"
                />
              </div>

              <div className="">
                <button className="rounded-full text-blue-900 w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                  {" "}
                  Y
                </button>
              </div>
              <div className="">
                <button className="rounded-full w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-blue-200 text-lg font-bold text-white outline-1 mx-2">
                  {" "}
                  M
                </button>
              </div>
              <div className="">
                <button className="rounded-full text-blue-900 w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2 ">
                  {" "}
                  W
                </button>
              </div>
            </div>
          </div>
          <div className="flex flex-wrap pb-2">
            <div className="w-full ml-4 mt-8 mb-10 font-Montserrat px-4 align-middle shadow-lg shadow-slate-400 sm:w-1/2 md:w-1/3 lg:w-1/5 xl:w-1/6  mx-1 rounded-2xl mr-6">
              <div className="text-center  mt-4 ">
                <div className="text-center">
                  <button className=" text-center rounded-full w-12  bg-cyan-200 text-lg font-bold outline-1 mx-2">
                    {" "}
                    <svg
                      className="relative top-1.5 left-1.5"
                      width="46"
                      height="46"
                      viewBox="0 0 32 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M21 6L15.7071 11.2929C15.3166 11.6834 14.6834 11.6834 14.2929 11.2929L12.7071 9.70711C12.3166 9.31658 11.6834 9.31658 11.2929 9.70711L7 14"
                        stroke="#1F78B4"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M3 3V17.8C3 18.9201 3 19.4802 3.21799 19.908C3.40973 20.2843 3.71569 20.5903 4.09202 20.782C4.51984 21 5.07989 21 6.2 21H21"
                        stroke="#1F78B4"
                        stroke-linecap="round"
                      />
                    </svg>
                  </button>
                </div>
              </div>
              <h1 className="text-4xl text-center font-bold mt-4">{Data?.perfect_schedule_rate}%</h1>
              <h1 className="text-lg text-center text-gray-500 mt-2 font-bold ">
                Rate of successful schedules
              </h1>
              <p className="text-lime-400 text-center mb-1 ">
                <span>
                  <span className="inline-block">
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 12 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7 7L7.70711 6.29289L7 5.58579L6.29289 6.29289L7 7ZM11.2071 9.79289L7.70711 6.29289L6.29289 7.70711L9.79289 11.2071L11.2071 9.79289ZM6.29289 6.29289L2.79289 9.79289L4.20711 11.2071L7.70711 7.70711L6.29289 6.29289Z"
                        fill="#26F32E"
                      />
                      <path
                        d="M7 3.5L7.70711 2.79289L7 2.08579L6.29289 2.79289L7 3.5ZM11.2071 6.29289L7.70711 2.79289L6.29289 4.20711L9.79289 7.70711L11.2071 6.29289ZM6.29289 2.79289L2.79289 6.29289L4.20711 7.70711L7.70711 4.20711L6.29289 2.79289Z"
                        fill="#26F32E"
                      />
                    </svg>
                  </span>
                </span>
                <span className="ml-1 font-medium">45.38%</span>
              </p>
              <div className="text-center m-auto flex justify-center ml-auto mt-1 mb-4 pt-3">
                <div className="">
                  <button className="rounded-full w-8 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                    {" "}
                    Y
                  </button>
                </div>
                <div className="">
                  <button className="rounded-full w-8 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                    {" "}
                    M
                  </button>
                </div>

                <div className="">
                  <button className="rounded-full w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-blue-200 text-lg font-bold text-white outline-1 mx-2">
                    {" "}
                    W
                  </button>
                </div>
              </div>
            </div>
            <div className="flex-2 md:overflow-x-auto overflow-x-auto  float-right ml-auto mr-4 mt-1">
              <div className="relative overflow-x-auto  sm:rounded-lg">
                <Chart
                  options={PerferctSchedule.options}
                  series={PerferctSchedule.series}
                  type="line"
                  height="380"
                  width="95%"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="flex mt-10 space-x-15 bg-white shadow-lg border-cyan-100 border-1 rounded-lg md:space-x-10 sm:space-x-5 pt-4 px-8 pb-8">
      <div className="flex">
      <div className="flex flex-wrap pb-2 -ml-8">
      <div><h3 className="text-lg font-bold mx-3">
      Current Jobs and Status    </h3>
            <Chart
              //@ts-ignore
              options={state.options}
              series={state.series}
              type="donut"
              width="380"
            /></div>
            <div className="flex-1 md:overflow-x-auto overflow-x-auto  float-right ml-auto mr-4 mt-1">
              <div className="relative overflow-x-auto  sm:rounded-lg">
                <CurrentjobTabledata />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
